import React from 'react';
import styled from '@emotion/styled';
import { Button } from 'antd';
import { Player, BigPlayButton, ControlBar } from 'video-react';
import { appStyles } from '../../../../styles';
import { UploadImage } from '../../../../assets';
import '../../../../../node_modules/video-react/dist/video-react.css';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  description?: string;
  title?: string;
  ctaText?: string;
  colorOpacity?: string;
  heading?: string;
  priceColor?: string;
  buttonBGColor?: string;
  buttonTextColor?: string;
  describeText?: string;
  describeText2?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  height?: string;
  className?: string;
}

export const PreviewTheDaily = (props: PreviewProps) => {
  const { values, height, className } = props;
  const {
    backgroundImage,
    backgroundVideo,
    title,
    describeText,
    ctaText,
    describeText2,
    ctaTextColor,
    ctaBackgroundColor,
    background,
    titleColor,
  } = values;
  const isDefaultImage = !(backgroundVideo || backgroundImage);
  const parseString = (str: string) => {
    const num: number = str.length;
    if (num > 50) {
      const newStr: string = str.substring(0, 25);
      return `${newStr}...`;
    }
    return str;
  };

  const viewImageOrVideo = () => {
    return backgroundVideo ? (
      <div className="style-video">
        <Player autoPlay playsInline src={backgroundVideo} fluid={false} width={322} height={400}>
          <BigPlayButton position="center" />
          <ControlBar className="control-bar" />
        </Player>
      </div>
    ) : (
      <img className="image-TheDaily" src={backgroundImage} alt="" />
    );
  };

  return (
    <StyledTheDailyPreview
      className={className}
      style={{ height: height || '300px', backgroundColor: background || '#efefef' }}
    >
      <div>
        <div className="preview-ant-image">
          <StyledLinearGradient />
          {!isDefaultImage ? (
            viewImageOrVideo()
          ) : (
            <div className="image-default">
              <img src={UploadImage} alt="" />
              <div className="describeText">{describeText}</div>
              <div className="describeText2">{describeText2}</div>
            </div>
          )}
        </div>
        <div className={backgroundVideo || isDefaultImage ? 'content-preview' : 'content-preview blur-image'}>
          {title && (
            <div className="heading center" style={{ color: titleColor || '#000' }}>
              {parseString(title)}
            </div>
          )}
          <div className="center">
            <Button
              className="btn-learn-more"
              style={{ background: ctaBackgroundColor || '#000', color: ctaTextColor || '#fff' }}
            >
              {ctaText || 'Watch Now'}
            </Button>
          </div>
        </div>
      </div>
    </StyledTheDailyPreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledTheDailyPreview = styled.div`
  margin: 1.5rem;
  min-height: 293px;
  position: relative;
  text-align: left;
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  & .control-bar {
    position: absolute;
    top: 0;
  }
  & .heading {
    width: 300px;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 20px;
    padding: 0 0.5rem;
  }
  & .sub-title {
    font-size: 15px;
    padding: 0.5rem 1rem;
  }
  & .btn-learn-more {
    font-weight: 600;
    border-radius: 25px;
    margin: 0 0 1rem 0.5rem;
    width: auto;
    height: 2.3rem;
    padding: 0 1rem;
    border: none;
  }
  & .image-border {
    border-bottom: 1px #c3c3c3 solid;
    overflow: hidden;
  }
  & .content-preview {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
  & .blur-image {
    backdrop-filter: blur(2px);
    padding-top: 1rem;
  }
  & .preview-ant-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
    height: 400px;
    & .image-TheDaily {
      width: 100%;
      height: 100%;
      object-fit: cover;
      padding: 0;
    }
    & .style-video {
    }
    & .image-default {
      justify-content: center;
      text-align: center;
      & img {
        width: 6rem;
        height: 6rem;
      }
      & .describeText {
        font-size: 17px;
        padding-top: 1rem;
        font-weight: 600;
      }
      & .describeText2 {
        font-size: 15px;
        padding-top: 0.5rem;
      }
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .logo-brand {
    margin: 0.7rem 1rem;
    & .logo-tm {
      width: 2.5rem;
      padding-right: 10px;
      height: auto;
    }
    & .img-partner {
      padding-left: 10px;
      width: auto;
      max-height: 3rem;
    }
  }
  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }
  }
`;
